// returns the closest containing element

export function getElement(node:Node):HTMLElement {
  if (!node) {
    return null;
  }

  return node.nodeType == Node.ELEMENT_NODE ? node as HTMLElement : node.parentElement;
}
